import Product from "./Product";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Pagination from "./Pagination";

axios.defaults.baseURL = "https://fullstack-node-app.vercel.app/";
axios.defaults.headers.common["Authorization"] =
  "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImRlbW9AZ21haWwuY29tIiwiaWF0IjoxNjc2NDkzNTI4fQ.VNWQDQJM9jDXrGofVLk3brpqlcNwFzjDmLLwfP9Rw4TM20IIuayvzubPJPfrkJb4kcRAUchdg7uy36rf9z-n9eLdcCw6FQLBBP7t0IA0NhFwjc0NjsJ50zUFgqPi8TAeVclD3DpjEoIRGbSrJpeVIBnLy6DeY7NcugJRbzKpW7iVq9WR9hO-mJ9n01zzEs3xJZ9Kyvq0dir680qPAtEdqLIvPstK8tDRNoYwcZXUthxSoDEAf-sp-E1qbuVv1WDlNpmBncWcUKFUgxeAuoFKRaYOy-9xrATE33C3wUW26Q9nUWJjDHiDw_Oe695P1UpTsKntGAWI_ECytTZhlA_pug";

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [currPage, setCurrPage] = useState(1);
  const [postPerPage, setPostPerPage] = useState(8);

  useEffect(() => {
    getProducts();
  }, []);

  const indexofLastPage = currPage * postPerPage;
  const indexofFirstPage = indexofLastPage - postPerPage;
  const currentPosts = products.slice(indexofFirstPage, indexofLastPage);

  const paginate = (pageNumber) => {
    if (
      pageNumber > 0 &&
      pageNumber <= Math.ceil(products.length / postPerPage)
    ) {
      setCurrPage(pageNumber);
    }
  };

  const getProducts = async () => {
    try {
      const res = await axios.get(`/products`);
      setProducts(res.data);
    } catch (error) {
      toast.error("Error fetching products");
    }
  };

  const handleClick = async (id) => {
    try {
      const res = await axios.delete(`/products/${id}`);
      if (res.data._id) {
        setProducts(products.filter((p) => p._id !== res.data._id));
      }
    } catch (error) {
      toast.error("Error deleting product");
    }
  };
  const handleBuy = () => {
    toast.success("Added to Cart");
  };

  const handleSort = async (e) => {
    const field = e.target.value.split(".");
    const sortField = field[0];
    const sortOrder = field[1];

    try {
      const res = await axios.get(
        `/products?sort=${sortField}&order=${sortOrder}`
      );
      let sortedProducts = res.data;

      sortedProducts.sort((a, b) => {
        if (sortOrder === "asc") {
          return a[sortField] - b[sortField];
        } else {
          return b[sortField] - a[sortField];
        }
      });

      setProducts(sortedProducts);
    } catch (error) {
      toast.error("Error sorting products");
    }
  };

  return (
    <div className="bg-gray-200 w-full min-h-screen">
      <div className="flex md:flex-row justify-around flex-wrap items-center">
        <div className="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6 w-full bg-gray-50">
          <div className="ml-4 mt-4 p-4 items-center rounded-md px-2 py-2 text-black ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0">
            <select
              onChange={handleSort}
              defaultValue={"default"}
              className="bg-gray-50 "
            >
              <option value={"default"}>Select Filter</option>
              <option value="price.desc">Price High to Low</option>
              <option value="price.asc">Price Low to High</option>
              <option value="rating.desc">Rating High to Low</option>
              <option value="rating.asc">Rating Low to High</option>
            </select>
          </div>
          <div className="mt-4 mx-4 p-4">
            <a
              href="/add"
              className="px-2 py-1 bg-indigo-600 text-white font-medium rounded-md shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-white sm:font-semibold sm:px-4 sm:py-2"
            >
              Add Product
            </a>
          </div>

          <Pagination
            postPerPage={postPerPage}
            totalPosts={products.length}
            paginate={paginate}
            currPage={currPage}
          />
        </div>
      </div>
      <div className="flex flex-wrap">
        {currentPosts.map((product) => (
          <Product
            {...product}
            key={product._id}
            handleClick={handleClick}
            handleBuy={handleBuy}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductList;
